import HeaderList from "../../components/HeaderList"
import { PageProps } from '../../components/types'
import DataGrid from 'react-data-grid'
import { PicklistStatus } from '../../constants/EnumType'
import { getColunmPicklist, PicklistCompleteColumn } from '../../constants/Column'

import { useCallback, useMemo, useState } from "react";

import useCompletedOrderPicklist from "../../hooks/useCompletedOrderPicklist"

const PicklistComplete = ({ title, division, line, from, to }: PageProps) => {
  const [orderType, setOrderType] = useState<string>(line || '')
  const [statuses, setStatuses] = useState<string[]>([ PicklistStatus.PD_RECORDED ])
  const [dateRange, setDateRange] = useState<[Date, Date]>([from || new Date(), to || new Date()]);
  const [keyword, setKeyword] = useState<string>('')
  const [div, setDiv] = useState<string>(division!)

  const picklists = useCompletedOrderPicklist(
    statuses[0], orderType, dateRange[0], dateRange[1], keyword, div)

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Order Type':
        return setOrderType(value)
      case 'Status':
        return setStatuses(values!)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      case 'Division':
        return setDiv(value)
      default:
        break
    }
  }, [])

  const coupleStatuses = useMemo(() => 
    [PicklistStatus.PD_RECORDED, PicklistStatus.PICKLIST_COMPLETED]
  , [])
  return <div className="page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division} - ${line}`}
      orderType={orderType}
      statuses={statuses}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      division={div}
    />
    <DataGrid className="mt-4" style={{ height: "100%", contain: "none" }}
      columns={getColunmPicklist(PicklistCompleteColumn)}
      rows={picklists}
      rowHeight={60}
    />
  </div>
}

export default PicklistComplete